// extracted by mini-css-extract-plugin
module.exports = {"header":"product-list_header__1ANc9","headerContainer":"product-list_headerContainer__2qRaO","productList":"product-list_productList__3yCd2","drawer":"product-list_drawer__2l99g"};